import {webRequest, webNoTokenRequest} from '../api'

// 記錄 API 錯誤資訊（前端發現錯誤時用）
export function sendErrorLog(data) {
    return webNoTokenRequest({
        url:'/v1/sys/apierrorlog',
        method:'post',
        data: data,
    })
}

// 登入紀錄
export function sendLoginLog(data) {
    return webRequest({
        url:'/oauth/log/login',
        method:'post',
        data: data,
    })
}

// 管家-進入畫面時寫log
export function sendEventLog(data) {
    return webRequest({
        url:'/v1/sys/oauth/landlord/event/record',
        method:'post',
        data: data,
    })
}


// WEBPACK FOOTER //
// ./src/apis/global/log.js